// @ts-ignore
import {Promise} from "es6-promise";
import $ = require('jquery');
import 'owl.carousel';
import Config = require("./config/Config");
import BackgroundLazyLoader = require("./service/BackgroundLazyLoader");
import {DesignView} from "./view/DesignView";
import ScrollView = require("./view/ScrollView");
import {ViewStatus} from "./event/EventStaus";
import {DisplayView} from "./view/DisplayView";
import {PerformanceView} from "./view/PerformanceView";
import {CoolingView} from "./view/CoolingView";
import {QualityView} from "./view/QualityView";
import {AudioView} from "./view/AudioView";
import {SoftwareView} from "./view/SoftwareView";
import {AccessoriesView} from "./view/AccessoriesView";
import PlayerView = require("./view/PlayerView");
import YTPlayer = require("./media/YTPlayer");


module app {

    $(function () {

        Config.init();
        loadYTApi();
        createLazyLoad();
        createScrollView();
        createView();
        createCarousel();
        $(window).on("resize", onWindowResize);
        onWindowResize(null);
    });

    /**
     * onResize
     * */
    function onWindowResize(event: JQuery.Event) {
        resizeOverviewGuide();
        resizeLoopVideo();
        refreshCarousel();
        if (renderViews && renderViews.length > 0) {
            for (let key in renderViews) {
                if (renderViews.hasOwnProperty(key)) {
                    renderViews[key].resize();
                }
            }
        }
    }

    function resizeOverviewGuide() {
        let baseW: number = $("#special-sectionOverview, #sectionOverview").width();
        let tw: number = window.innerWidth > Config.maxWidth ? Config.maxWidth : window.innerWidth;
        let tx: number = (baseW - tw) * 0.5;
        $(".overviewGuide").css({
            'left': tx + 'px',
            'width': tw + 'px'
        });
    }


    /**
     * LazyLoad
     * */
    let lazyLoader: BackgroundLazyLoader;

    function createLazyLoad() {
        lazyLoader = new BackgroundLazyLoader({className: '.lazy'});
    }


    /*
    * YoutubeApi
    * */
    function loadYTApi() {
        const myDoc = (<any>window).document;
        let playerApiScript = myDoc.createElement('script');
        playerApiScript.type = 'text/javascript';
        playerApiScript.src = 'https://www.youtube.com/iframe_api';
        myDoc.body.appendChild(playerApiScript);
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(playerApiScript, firstScriptTag);
        (<any>window).onYouTubeIframeAPIReady = () => {
            console.log("Youtube Api Loaded!!!!");
            createPlayerView();
            createLoopPlayer();
        };
    }


    let playerView: PlayerView;

    function createPlayerView() {
        playerView = new PlayerView(100, $("#rog-youtube"));

        $(".mainVideoBtn").removeClass("disabled");
        $(".mainVideoBtn").on("click tap", event => {
            event.preventDefault();
            playerView.playVideo("0VvU6eVrmpE");
        });
        $(".displayVideoBtn").removeClass("disabled");
        $(".displayVideoBtn").on("click tap", event => {
            event.preventDefault();
            playerView.playVideo("C3DJ8kvebvM");
        });
    }

    let loopPlayer: YTPlayer;

    function createLoopPlayer() {
        loopPlayer = new YTPlayer("loopYTPlayer", "0VvU6eVrmpE", true, true, false);
        loopPlayer.emitter.on(YTPlayer.VideoEvent.PLAYER_READY, () => {
        });
        loopPlayer.emitter.on(YTPlayer.VideoEvent.ON_PLAYING, () => {
            // console.log("Youtube is Playing");
            $(".mainVideoBtn").addClass("hidden");
        });
    }

    function resizeLoopVideo() {
        let videoMask: JQuery = $(".kvView").find(".video-mask");
        let videoCon: JQuery = $(".kvView").find(".video-container");
        let tw: number = 0;
        let th: number = 0;
        if (videoMask.width() > videoMask.height()) {
            tw = videoMask.width();
            th = tw / 16 * 9;
        } else {
            th = videoMask.height();
            tw = th / 9 * 16;
        }
        videoCon.width(tw);
        videoCon.height(th);
    }


    /**
     * Views
     * */
    let renderViews: any[];

    function createView() {

        renderViews = [];
        let designView = new DesignView<JQuery>($(".designView"));
        renderViews.push(designView);

        let displayView = new DisplayView<JQuery>($(".displayView"));
        renderViews.push(displayView);

        let performanceView = new PerformanceView<JQuery>($(".performanceView"));
        renderViews.push(performanceView);

        let coolingView = new CoolingView<JQuery>($(".coolingView"));
        renderViews.push(coolingView);

        let qualityView = new QualityView<JQuery>($(".qualityView"));
        renderViews.push(qualityView);

        let audioView = new AudioView<JQuery>($(".audioView"));
        renderViews.push(audioView);

        let softwareView = new SoftwareView<JQuery>($(".softwareView"));
        renderViews.push(softwareView);

        let accessoriesView = new AccessoriesView<JQuery>($(".accessoriesView"));
        renderViews.push(accessoriesView);

        for (let i: number = 0; i < renderViews.length; i++) {
            let targetView = renderViews[i];
            targetView.init();
            targetView.eventEmitter.on((event: string, arg: any) => {
                if (event == ViewStatus.SCROLL_TO) {
                    scrollView.scrollTo(arg);
                }
            });
        }

        $(".topBtn").on("click tap", (event: JQuery.Event) => {
            event.preventDefault();
            scrollView.scrollTo(0);
        });

        setTimeout(() => {
            $(".preloadView").fadeOut(500);
        }, 1000);
    }


    /**
     * ScrollView
     * */
    let scrollView: ScrollView;
    let scrollTop: number;

    function createScrollView(): void {
        scrollView = new ScrollView($(window), $("body,html"));
        scrollView.emitter.on(ScrollView.ScrollEvent.ON_SCROLL, onWindowScroll);
        scrollTop = scrollView.getScrollTop();
    }

    function onWindowScroll(result: number): void {
        scrollTop = result;
        if (scrollTop > 200) {
            $(".topBtn").addClass("active");
        } else {
            $(".topBtn").removeClass("active");
        }
        // console.log("scrollTop", scrollTop);
        if (renderViews && renderViews.length > 0) {
            for (let key in renderViews) {
                if (renderViews.hasOwnProperty(key)) {
                    renderViews[key].onScroll(scrollTop);
                }
            }
        }
    }

    function scrollToElement(target: JQuery) {
        scrollView.scrollToElement(target, 0);
    }


    /**
     * Carousel
     * */
    let allCarousel: any[];

    function createCarousel() {

        allCarousel = [];
        let carouselTotal: number = $(".overviewGuide").find(".basic-carousel-container").length;
        for (let i: number = 0; i < carouselTotal; i++) {
            let container: JQuery = $(".overviewGuide").find(".carousel-container:eq(" + i + ")");
            let carousel: any = container.find(".carousel");
            carousel.owlCarousel({
                items: 1,
                margin: 10,
                lazyLoad: true,
                touchDrag: true,
                mouseDrag: true,
                nav: false,
                dots: true,
                dotsSpeed: 800
            });
            allCarousel.push(carousel);

            let prevBtn = container.find(".carousel-control-prev");
            let nextBtn = container.find(".carousel-control-next");
            prevBtn.on("click tap", event => {
                event.preventDefault();
                carousel.trigger('prev.owl.carousel', [800]);
            });

            nextBtn.on("click tap", event => {
                event.preventDefault();
                carousel.trigger('next.owl.carousel', [800]);
            });
        }
    }

    function refreshCarousel() {
        if (!allCarousel) return;
        for (let i: number = 0; i < allCarousel.length; i++) {
            let carousel = allCarousel[i];
            carousel.trigger('refresh.owl.carousel');
        }
    }

}